(function (win, ss) {
  var ClipsToolbar = ss.utils.imports('clips.Toolbar'),
      clipsToolbar = null;

  function initClipsToolbar() {
    // TODO: Gate this to SV only through the app, not through JS.
    if ($('#svPlayerId').length === 0) { return; }

    if ($.slideshareEventManager && $.slideshareEventManager.controller){
      clipsToolbar = new ClipsToolbar();
    } else {
      $(document).on('slideshare-player-controller:init-done', function() {
        clipsToolbar = new ClipsToolbar();
      });
    }
  }

  initClipsToolbar();
}(window, window.slideshare_object));